import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import {
  AlertCreateInput,
  ConversationAnalysisAlertsApi,
} from '@/Domain/api/Conversation/ConversationAnalysisAlerts.api';
import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';

export const useConversationAnalysisAlertCreate = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationAnalysisAlerts.create}-create`],
    mutationFn: (alert: AlertCreateInput) => ConversationAnalysisAlertsApi.create(alert),
    onSuccess: (data) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationAnalysisAlerts.list}-list`],
        (prev: AlertDto[] | undefined) => [...(prev ?? []), data],
      );
      toast.success(t('toast.create_alert.success'));
    },
    onError: (error: AxiosError) => {
      toast.error(
        get(error, 'response.data.errors.root[0].message') || t('toast.create_alert.error'),
      );
    },
  });

  const handleCreateAlert = (alert: AlertCreateInput) => mutation.mutateAsync(alert);

  return { handleCreateAlert, isPending: mutation.isPending };
};
